import { render } from "./MonthlyPromo.vue?vue&type=template&id=e3673054&scoped=true"
import script from "./MonthlyPromo.vue?vue&type=script&lang=js"
export * from "./MonthlyPromo.vue?vue&type=script&lang=js"

import "./MonthlyPromo.vue?vue&type=style&index=0&id=e3673054&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3673054"]])

export default __exports__